import { API_URL } from '../config/api';

export function feLog(level, event, message, context) {
    try {
        fetch(API_URL + 'metrics/frontend-log', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ level, event, message, context }),
            keepalive: true,
        }).catch(() => {});
    } catch (e) {
        // fire-and-forget — never throw
    }
}
